export enum ROUTES {
  ROOT = '/',
}
